import React from 'react';
import { Calendar, User } from 'lucide-react';
import Footer from '../components/Footer';

const welcomeArticle = {
  title: "Welcome to the BGN Private Beta",
  category: "Community",
  author: "BGN Team",
  date: "2026-04-17",
  excerpt:
    "Black Gamers Network is officially live for our first wave of beta testers. Here's what you can explore, what's coming, and how to make your voice heard.",
  imageUrl:
    "https://customer-assets.emergentagent.com/job_gamers-unite/artifacts/6of96a1d_bgn%20logo.png",
  body: [
    "We've been building BGN with one goal in mind: a platform made by and for Black gamers. Today, we're opening the doors to our first group of beta testers — and we couldn't be more excited to have you here.",
    "During this beta you'll be able to explore streamer profiles, browse the community, and connect with others in the network. Your feedback during this period is critical. If something feels off, doesn't load, or could be better — we want to know.",
    "A few things to look forward to as we continue building: the store will be launching with official BGN merchandise, the news section will grow with community stories and updates, and streamer features will keep expanding.",
    "To share feedback or report anything, head to the Contact page or DM us on Instagram. Thank you for being part of this from the beginning.",
  ],
};

const formatDate = (dateString) =>
  new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

const NewsPage = () => {
  const a = welcomeArticle;

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="py-24 bg-bgn-black">
        <div className="max-w-6xl mx-auto px-4 lg:px-8 text-center">
          <h1 className="text-5xl lg:text-7xl font-bold mb-8 text-white">BGN News</h1>
          <p className="text-xl lg:text-2xl text-bgn-grey leading-relaxed max-w-4xl mx-auto">
            Stories, updates, and insights from the Black gaming community
          </p>
        </div>
      </section>

      {/* Article */}
      <section className="py-24 bg-bgn-black">
        <div className="max-w-3xl mx-auto px-4 lg:px-8">
          <div className="mb-6">
            <span className="bg-bgn-gold text-bgn-black px-3 py-1 text-sm font-bold">
              {a.category}
            </span>
          </div>

          <h2 className="text-3xl lg:text-5xl font-bold text-white leading-tight mb-6">
            {a.title}
          </h2>

          <div className="flex items-center space-x-6 text-sm text-bgn-grey mb-10">
            <div className="flex items-center space-x-1">
              <User size={14} />
              <span>{a.author}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Calendar size={14} />
              <span>{formatDate(a.date)}</span>
            </div>
          </div>

          <div className="flex justify-center mb-12">
            <img
              src={a.imageUrl}
              alt="BGN"
              className="w-32 opacity-80"
              style={{ filter: 'grayscale(100%)' }}
            />
          </div>

          <div className="space-y-6">
            {a.body.map((paragraph, i) => (
              <p key={i} className="text-lg text-bgn-grey leading-relaxed">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NewsPage;
